var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1416 1624",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h1416v1624h-1416z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(880)",
    d: "m0 0h56v60h34l9 4 8 7 4 8 1 5 1 31 33 1 12 6 6 7 3 6 1 5v63l-3 10-4 6-6 5-10 4h-11l-10-4-8-8-4-10-1-33h-54l-1 85-3 12-7 8-9 5-5 1-87 1-1 55h34l10 4 5 4 5 8 2 9v87l56-1v-33l4-10 4-5 10-6 3-1 35-1-1-54-33-1-10-4-7-7-4-8-1-3v-12l4-10 4-5 10-6 3-1h69l9 4 8 7 4 8 1 5v118l-2 9-6 9-10 6-6 2-14 1h-17l-1 30-3 10-4 6-6 5-6 3-5 1-367 1-1 54v85l-2 10-3 6-5 5-8 5-6 2-24 1h-7l-1 30-3 10-6 8-10 6-4 1h-10l-8-3-6-4-6-7-3-8-1-33h-110l-1 31-4 11-7 8-8 4-4 1h-10l-11-4-8-8-4-10-1-33-33-1-10-4-8-8-4-10v-12l4-10 6-7 8-4 3-1 91-1v-33l4-10 5-6 12-6h13l10 4 5 4 4 6 3 9 1 32h55v-33l4-10 4-5 10-6 3-1 35-1-1-54-33-1-10-4-8-8-4-10v-12l4-10 4-5 10-6 3-1 35-1v-33l4-10 5-6 12-6h13l10 4 7 7 4 8 1 5 1 31h55v-33l4-10 7-7 10-5 35-1v-33l4-10 4-5 10-6 4-1 34-1-1-166-33-1-10-4-8-8-4-10v-12l4-10 4-5 7-5 6-2h69l10 4 7 7 4 8 1 5 1 31h55l-1-54-32-1-10-4-6-5-7-15v-9l4-11 4-5 15-7 32-1z",
    fill: "#201E1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,732)",
    d: "m0 0h18l10 4 7 7 4 8 1 5v32h34l9 3 7 6 5 10 1 4v10l-4 11-7 7-8 4-4 1h-33v112h34l9 4 8 7 4 9 1 4 1 31h20l13 1 12 6 6 7 3 7 1 5 1 30 145 1 10 4 5 4 5 8 2 8v63l-4 13-7 7-8 4-4 1h-11l-10-4-8-8-4-10-1-33h-110l-1 30-2 8-3 6-8 7-6 3-5 1h-88v56h34l9 3 6 5 5 8 2 7v10l-4 11-7 7-8 4-4 1h-33v56l56-1v-33l3-9 7-8 8-4 3-1h13l8 3 7 5 5 8 2 7v64l-2 8-3 6-8 7-10 4-32 1-1 85-2 9-5 8-6 5-10 4h-33v56l56-1v-33l4-10 4-5 10-6 3-1h13l10 4 7 7 4 8 1 5v63l-2 8-4 7-5 6h-141z",
    fill: "#201E1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1349,284)",
    d: "m0 0h13l10 4 5 4 4 6 2 5 1 6v143h32v448h-32v31l-2 8-5 8-6 5-9 4h-12l-10-4-8-8-4-10-1-33-33-1-8-3-10-9-4-10v-12l4-10 4-5 7-5 6-2 35-1v-33l4-10 4-5 10-6 3-1 35-1-1-54-34-1-10-5-8-9-3-8v-12l4-10 5-6 9-5 3-1 34-1v-110l-89-1-10-4-8-8-4-10v-12l4-10 4-5 7-5 6-2 34-1v-54l-89-1-10-4-8-8-4-10v-12l4-10 4-5 7-5 6-2 35-1v-33l4-10 5-6 9-5 3-1 35-1v-33l4-10 5-6 9-5z",
    fill: "#201E1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1125,396)",
    d: "m0 0h13l9 3 6 5 4 6 3 9v89h34l10 4 5 4 5 8 2 8v62l-3 12-7 8-10 5-4 1-80 1h-7l-1 30-2 8-3 6-8 7-6 3-5 1-143 1-1 111h34l10 4 5 4 5 8 2 7v10l-4 11-7 7-8 4-5 1h-121l-11-4-8-8-4-10v-12l4-10 5-6 9-5 3-1 34-1 1-145 4-10 4-5 10-6 4-1 34-1v-33l4-10 5-6 9-5 3-1h13l10 4 5 5 5 8 2 7 1 31h55v-33l4-10 5-6 12-6 35-1-1-54-34-1-10-5-7-8-4-9v-12l4-10 8-8 9-4 34-1 1-33 4-10 5-6 9-5z",
    fill: "#201E1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(733,1068)",
    d: "m0 0h13l10 4 7 7 4 8 1 5 1 31h55v-33l3-9 7-8 8-4 3-1h13l10 4 5 4 4 6 3 10v32l56-1v-33l4-10 5-6 9-5 3-1h13l10 4 5 4 4 6 3 10v229l-2 10-3 6-8 7-6 3-5 1h-66l-10-4-8-8-4-10v-12l4-10 4-5 7-5 6-2 35-1-1-54-33-1-10-4-8-8-4-10-1-33-201-1-10-4-7-7-4-8-1-3v-12l4-10 4-5 10-6 3-1 35-1v-33l4-10 5-6z",
    fill: "#201E1F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(677,1404)",
    d: "m0 0h69l10 4 7 7 4 8 1 5v88l56-1v-89l3-9 7-8 8-4 3-1h13l10 4 5 4 5 8 2 8v196h-280v-29l3-10 5-6 10-6 3-1 34-1 1-33 4-10 4-5 10-6 4-1 34-1-1-54-33-1-10-4-7-7-4-8-1-3v-12l4-10 4-5 10-6z",
    fill: "#201E1F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1405,1236)",
    d: "m0 0h11v388h-88v-52h-34l-9-4-8-7-4-8-1-3v-12l4-10 4-5 7-5 6-2 35-1-1-110-32-1-9-3-8-7-4-6-2-6v-68l4-10 5-5 5-4 7-3 91-1v-33l3-9 6-7z",
    fill: "#201E1F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h264v90l-3 12-7 8-9 5-5 1-143 1-1 30-2 8-3 6-9 8-5 2-6 1h-71z",
    fill: "#201E1F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(568,4)",
    d: "m0 0h9l11 4 7 8 4 9 1 5v30h34l10 4 5 4 5 8 2 8v144h34l10 4 5 4 5 8 2 6v11l-4 11-7 7-8 4-4 1-32 1-1 84-2 10-6 9-9 6-6 2h-10l-10-4-8-7-4-8-1-3-1-33-34-1-10-5-7-8-4-9v-12l4-10 8-8 9-4 35-1-1-110-33-1-8-3-10-9-4-10-1-33-32-1-11-4-6-7-5-10-1-3v-9l4-11 4-5 15-7 32-1 1-32 4-11 5-5 11-6z",
    fill: "#201E1F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1237,116)",
    d: "m0 0h179v56l-87 1-1 84-2 10-5 8-6 5-10 4h-11l-10-4-8-8-4-10-1-33h-54l-1 31-3 10-7 8-9 5-4 1-24 1h-8l-1 31-3 9-4 6-6 5-9 4h-12l-10-4-8-8-4-10-1-33-34-1-8-4-7-6-6-12v-12l4-10 4-5 7-5 6-2 91-1v-33l4-10 4-5 10-6 4-1 34-1v-33l4-10 4-5 10-6z",
    fill: "#201E1F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(565,1124)",
    d: "m0 0h13l10 4 7 7 4 8 1 5v62l-3 12-7 8-9 5-5 1-87 1-1 30-2 8-3 6-9 8-10 3-136 1h-7l-1 30-3 10-4 6-6 5-11 4h-66l-10-4-8-8-4-10v-12l4-10 4-5 7-5 6-2 35-1v-33l4-10 4-5 10-6 3-1 35-1v-33l4-10 5-6 6-4 6-2h13l10 4 5 4 4 6 3 10 1 31h55v-33l4-10 4-5 7-5 6-2 91-1v-33l4-10 4-5 10-6z",
    fill: "#201E1F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(566,732)",
    d: "m0 0h12l9 4 7 6 5 10 1 5 1 30 89 1 10 4 5 4 5 8 2 7v10l-4 10-7 8-8 4-5 1h-88v56h146l10 4 5 4 5 8 2 8v63l-2 8-3 6-8 7-10 4h-11l-10-4-8-8-4-10-1-33-145-1-9-4-9-8-3-6-1-5v-179l4-10 8-8z",
    fill: "#201E1F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(453,900)",
    d: "m0 0h13l10 4 5 5 5 8 2 7 1 31h19l14 1 12 6 6 7 3 6 1 6v116l-2 10-5 8-6 5-6 3-5 1h-66l-10-4-8-8-4-10-1-33-32-1-9-3-10-9-4-10v-68l4-10 4-5 10-6 3-1 34-1 1-33 4-10 6-7 8-4z",
    fill: "#201E1F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(453,172)",
    d: "m0 0h69l10 4 8 8 4 11v64l-3 10-4 6-8 6-8 3-32 1v54l33 1 9 4 8 7 4 8 1 4v10l-4 10-7 8-8 4-5 1h-66l-10-4-8-8-4-10-1-33-33-1-8-3-10-9-4-10v-68l4-10 5-6 12-6 35-1v-33l4-10 5-6z",
    fill: "#201E1F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1013,844)",
    d: "m0 0h13l10 4 5 5 5 8 2 7v32h34l10 4 5 4 5 8 2 7v10l-4 11-7 7-8 4-4 1h-33v56h90l10 4 6 5 5 10 1 4v10l-4 11-7 7-8 4-4 1h-123l-10-4-8-8-4-10-1-89-88-1-9-3-10-9-4-10v-12l4-10 4-5 7-5 6-2 91-1v-33l4-10 5-6 6-4z",
    fill: "#201E1F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(677,564)",
    d: "m0 0h69l10 4 5 5 5 8 2 8v31h34l10 4 5 4 5 8 2 7v10l-4 11-7 7-8 4-4 1-32 1-1 55h34l10 4 5 4 5 8 2 7v10l-4 11-7 7-8 4-5 1h-66l-9-4-8-7-4-7-1-4-1-33-89-1-7-3-8-6-6-10-1-3v-12l4-9 7-8 10-5 91-1-1-54-33-1-10-4-8-8-4-10v-12l4-10 5-6 9-5z",
    fill: "#201E1F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1069,1124)",
    d: "m0 0h69l9 3 7 6 5 10 1 3v11l-4 11-7 7-8 4-4 1h-33l1 55h111v-33l4-10 5-6 9-5 3-1h13l9 3 6 5 5 8 2 7v62l-2 10-5 8-6 5-11 4h-177l-9-3-8-7-5-8-1-4v-124l4-10 5-6 9-5z",
    fill: "#201E1F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(229,340)",
    d: "m0 0h13l10 4 7 7 4 8 1 5 1 31 145 1 10 4 6 5 5 10 1 4v10l-4 11-7 7-8 4-5 1-143 1-1 29-2 9-5 8-6 5-6 3-5 1h-65l-9-3-10-9-4-10v-68l4-10 4-5 10-6 3-1 35-1v-33l4-10 5-6z",
    fill: "#201E1F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(229,788)",
    d: "m0 0h13l9 3 6 5 6 11 1 4v33h34l10 4 5 4 5 8 2 8v63l-2 8-3 6-8 7-10 4-32 1-1 30-2 8-3 6-9 8-10 3h-67l-10-5-7-8-4-9v-12l4-10 4-5 10-6 3-1 35-1-1-54-34-1-10-5-7-7-4-10v-12l4-10 4-5 7-5 6-2 34-1 1-33 4-10 5-6 9-5z",
    fill: "#201E1F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1237,900)",
    d: "m0 0h13l10 4 7 7 4 8 1 4 1 32 33 1 9 4 8 7 4 8 1 5v32h34l10 4 5 4 5 8 2 7v10l-4 11-7 7-8 4-5 1-31 1-1 86-2 8-4 7-7 6-6 3-4 1h-11l-10-4-8-8-4-10-1-145-89-1-10-4-8-8-4-10v-12l4-10 4-5 7-5 6-2 34-1 1-33 3-9 6-7 9-5z",
    fill: "#201E1F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1125,1460)",
    d: "m0 0h125l9 3 6 5 4 6 3 9v10l-4 11-7 7-8 4-5 1-87 1-1 30-2 8-3 6-8 7-6 3-6 1-86 1-1 31-3 10-8 10h-90l-8-10-3-8v-12l4-10 4-5 10-6 3-1 35-1v-33l4-10 4-5 7-5 6-2 91-1v-33l4-10 4-5 10-6z",
    fill: "#201E1F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1237,620)",
    d: "m0 0h69l10 4 5 4 5 8 2 7v10l-4 11-7 7-8 4-4 1h-33l1 55 33 1 10 4 7 7 4 8 1 4v10l-4 10-7 8-8 4-5 1h-65l-9-3-10-9-4-10v-124l4-10 4-5 10-6z",
    fill: "#201E1F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,564)",
    d: "m0 0h74l10 4 5 4 5 8 2 8v32h34l10 4 6 5 5 10 1 3v11l-4 11-7 7-8 4-4 1h-33v31l-3 10-6 8-7 5-6 2h-12l-10-4-8-8-4-10-1-89-39-1z",
    fill: "#201E1F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(621,1236)",
    d: "m0 0h13l10 4 5 4 5 8 2 7v119l-2 9-5 8-6 5-6 3-5 1h-66l-8-3-10-9-4-10v-12l4-10 4-5 7-5 6-2 35-1v-89l4-10 5-6z",
    fill: "#201E1F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(341,1348)",
    d: "m0 0h125l10 4 5 4 4 6 3 9v10l-4 11-7 7-8 4-5 1-87 1-1 31-3 10-8 9-8 4-4 1h-10l-11-4-8-8-4-10v-68l4-10 4-5 10-6z",
    fill: "#201E1F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1013,1348)",
    d: "m0 0h13l10 4 5 4 4 6 3 10v32h34l10 4 5 4 4 6 3 9v10l-4 10-7 8-8 4-5 1h-121l-9-3-8-7-4-6-2-6v-12l4-10 4-5 7-5 6-2 35-1v-33l4-10 5-6 6-4z",
    fill: "#201E1F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(397,1460)",
    d: "m0 0h125l10 4 5 4 4 6 3 9v10l-4 11-7 7-8 4-5 1h-122l-8-3-9-8-4-8-1-3v-12l4-10 5-6 9-5z",
    fill: "#201E1F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(733,1236)",
    d: "m0 0h69l10 4 5 4 5 8 2 7v10l-4 11-7 7-8 4-4 1h-33v32l-3 10-7 8-9 5-4 1h-11l-10-4-8-8-4-10v-68l4-10 4-5 7-5z",
    fill: "#201E1F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(6,284)",
    d: "m0 0h12l10 4 7 7 4 8 1 5v173l-2 10-6 9-5 4-6 3-4 1h-10l-7-2v-220z",
    fill: "#201E1F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(397,732)",
    d: "m0 0h69l10 4 7 7 4 8 1 4v64l-3 10-4 6-6 5-6 3-4 1h-11l-10-4-8-8-4-10-1-33-33-1-10-4-8-8-4-10v-12l4-10 5-6 9-5z",
    fill: "#201E1F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1128,4)",
    d: "m0 0h9l11 4 5 5 6 12 1 4v62l-2 8-3 6-8 7-6 3-5 1h-65l-10-4-6-5-7-15v-9l4-11 4-5 15-7 33-1v-32l4-11 5-5 11-6z",
    fill: "#201E1F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h168l1 2 8 1 31 1v55l-3 1h-53l-1-30-4-12-6-8-8-4-4-1h-9l-10 4-8 5-4 9-1 4-1 32-5 1h-51l-1-30-3-9-5-10-10-5-4-1h-10l-7 2z",
    fill: "#FEFEFE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,1010)",
    d: "m0 0 7 1 31 1 2 1 1 32 3 8 4 6 8 6 6 2 33 1 1 1v54l-3 1h-52l-1-1-1-30-3-10-4-6-6-5-8-3h-12l-6 1z",
    fill: "#FEFEFE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(117,284)",
    d: "m0 0h69l10 4 6 5 5 10 1 4v10l-4 11-7 7-8 4-5 1h-65l-9-3-8-7-4-6-2-6v-12l4-10 6-7 8-4z",
    fill: "#201E1F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(285,508)",
    d: "m0 0h69l10 4 5 4 5 8 2 7v10l-4 11-7 7-8 4-5 1h-66l-10-4-7-7-4-8-1-3v-12l4-10 4-5 7-5z",
    fill: "#201E1F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(229,172)",
    d: "m0 0h13l10 4 7 7 4 8 1 5v63l-3 10-4 6-6 5-10 4h-11l-10-4-8-8-4-10v-68l4-10 5-6z",
    fill: "#201E1F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(285,1572)",
    d: "m0 0h69l10 4 5 4 4 6 2 5 1 6v27h-101l-8-10-3-8v-12l4-10 4-5 7-5z",
    fill: "#201E1F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1384,1348)",
    d: "m0 0h32v112h-32z",
    fill: "#FEFEFE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1384,1516)",
    d: "m0 0h32v108h-32l-1-54z",
    fill: "#FEFEFE"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1289)",
    d: "m0 0h95v34l-4 13-4 5-8 5-8 3h-8l-11-4-6-5-6-12-1-4v-31h-27l-11-1z",
    fill: "#201E1F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(769,396)",
    d: "m0 0h54l1 1v54l-2 1h-54v-55z",
    fill: "#FEFEFE"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(432)",
    d: "m0 0h56v35l-4 13-5 5-15 7h-8l-12-4-7-8-5-12z",
    fill: "#201E1F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(320)",
    d: "m0 0h56v35l-3 10-4 6-10 6-7 3h-8l-12-4-7-8-5-12z",
    fill: "#201E1F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(768)",
    d: "m0 0h56v34l-4 13-4 5-16 8h-9l-12-5-6-7-5-12z",
    fill: "#201E1F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(768,1572)",
    d: "m0 0h55l1 1v51h-56z",
    fill: "#FEFEFE"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1237,1572)",
    d: "m0 0h13l10 4 7 7 4 8 1 5v28h-56v-30l4-10 5-6z",
    fill: "#201E1F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(789,1348)",
    d: "m0 0h13l10 4 5 4 4 6 3 9v10l-4 11-7 7-8 4-4 1h-11l-9-4-8-7-4-8-1-3v-12l4-10 6-7 8-4z",
    fill: "#201E1F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1181,1068)",
    d: "m0 0h13l10 4 5 5 4 5 3 9v10l-4 10-7 8-8 4-4 1h-11l-10-4-8-8-4-10v-12l4-10 6-7 8-4z",
    fill: "#201E1F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(285,732)",
    d: "m0 0h13l10 4 5 4 5 8 2 7v10l-4 10-7 8-8 4-4 1h-11l-10-4-7-7-4-8-1-3v-12l4-10 6-7z",
    fill: "#201E1F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(285,1460)",
    d: "m0 0h13l10 4 5 4 5 8 2 7v10l-4 10-7 8-8 4-4 1h-10l-9-3-9-8-4-8-1-3v-12l4-10 6-7z",
    fill: "#201E1F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(229,1404)",
    d: "m0 0h13l10 4 5 4 4 6 3 9v10l-4 11-7 7-8 4-4 1h-11l-10-4-8-8-4-10v-12l4-10 5-6z",
    fill: "#201E1F"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(341,172)",
    d: "m0 0h13l10 4 5 4 4 6 3 9v10l-4 11-7 7-8 4-4 1h-10l-9-3-9-8-4-8-1-3v-12l4-10 6-7z",
    fill: "#201E1F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(285,116)",
    d: "m0 0h13l10 4 5 4 4 6 3 9v10l-4 11-7 7-8 4-4 1h-10l-9-3-9-8-4-8-1-3v-12l4-10 6-7 8-4z",
    fill: "#201E1F"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(173,1460)",
    d: "m0 0h13l10 4 5 4 5 8 2 6v11l-4 10-7 8-8 4-4 1h-11l-9-4-8-7-4-8-1-3v-12l4-10 5-6z",
    fill: "#201E1F"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(789,1012)",
    d: "m0 0h13l10 4 5 5 5 8 2 6v10l-4 11-7 7-11 5h-12l-9-4-8-7-4-8-1-3v-12l4-10 6-7 8-4z",
    fill: "#201E1F"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1125,676)",
    d: "m0 0h13l10 4 5 4 4 6 3 9v10l-4 10-7 8-8 4-4 1h-10l-9-3-9-8-4-8-1-3v-12l4-10 6-7 8-4z",
    fill: "#201E1F"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1237,284)",
    d: "m0 0h13l10 4 5 4 4 6 3 9v10l-4 11-7 7-8 4-4 1h-10l-9-3-9-8-4-8-1-3v-12l4-10 5-6z",
    fill: "#201E1F"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(565,1516)",
    d: "m0 0h13l10 4 5 4 6 11 1 4v10l-4 10-7 8-8 4-4 1h-10l-8-3-6-4-6-7-3-8v-12l4-10 6-7 8-4z",
    fill: "#201E1F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(677,1012)",
    d: "m0 0h13l10 4 5 4 4 6 3 9v10l-4 10-7 8-8 4-4 1h-10l-9-3-10-9-4-10v-12l4-10 5-6z",
    fill: "#201E1F"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(229,676)",
    d: "m0 0h13l10 4 5 4 4 6 3 9v10l-4 11-7 7-8 4-4 1h-11l-9-4-8-7-4-8-1-3v-12l4-10 5-6z",
    fill: "#201E1F"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(397,116)",
    d: "m0 0h13l10 4 5 4 6 11 1 4v10l-4 11-7 7-8 4-4 1h-11l-9-4-8-7-4-8-1-3v-12l4-10 5-6 9-5z",
    fill: "#201E1F"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1069,788)",
    d: "m0 0h13l10 4 7 7 4 8 1 4v10l-4 10-7 8-11 5h-12l-10-4-8-8-4-10v-12l4-10 5-6 9-5z",
    fill: "#201E1F"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1125,1348)",
    d: "m0 0h13l10 4 7 7 4 8 1 4v10l-4 10-7 8-8 4-4 1h-11l-10-4-8-8-4-10v-12l4-10 5-6 9-5z",
    fill: "#201E1F"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(229,1180)",
    d: "m0 0h13l10 4 5 4 4 6 3 9v10l-4 10-7 8-8 4-4 1h-10l-9-3-9-8-4-8-1-3v-12l4-10 5-6z",
    fill: "#201E1F"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(621,1068)",
    d: "m0 0h13l10 4 5 4 4 6 3 9v10l-4 10-6 7-9 5-4 1h-10l-8-3-6-4-6-7-3-8v-12l4-10 5-6z",
    fill: "#201E1F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(117,900)",
    d: "m0 0h13l10 4 5 4 4 6 3 9v10l-4 10-6 7-12 6h-12l-9-4-8-7-4-8-1-3v-12l4-10 5-6z",
    fill: "#201E1F"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(229,564)",
    d: "m0 0h13l10 4 5 4 6 11 1 4v10l-4 10-7 8-8 4-4 1h-11l-9-4-8-7-4-8-1-3v-12l4-10 5-6z",
    fill: "#201E1F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1014,4)",
    d: "m0 0h12l10 4 5 5 4 5 3 9v10l-4 11-7 7-8 4-4 1h-11l-9-4-8-7-4-8-1-3v-12l4-10 5-6 9-5z",
    fill: "#201E1F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(678,4)",
    d: "m0 0h11l11 4 7 7 4 8 1 4v10l-4 10-7 8-8 4-4 1h-11l-9-4-8-7-4-8-1-3v-12l4-10 5-6 9-5z",
    fill: "#201E1F"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(285,284)",
    d: "m0 0h13l10 4 5 4 4 6 3 9v10l-4 10-7 8-8 4-4 1h-10l-9-3-9-8-5-11v-12l4-10 5-6z",
    fill: "#201E1F"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(61,228)",
    d: "m0 0h13l10 4 7 7 4 8 1 5v9l-4 10-7 8-8 4-4 1h-10l-9-3-9-8-4-8-1-3v-12l4-10 5-6 9-5z",
    fill: "#201E1F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(453,508)",
    d: "m0 0h13l10 4 7 7 4 8 1 4v10l-4 10-7 8-8 4-4 1h-10l-9-3-9-8-4-8-1-3v-12l4-10 5-6z",
    fill: "#201E1F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1238,4)",
    d: "m0 0h12l10 4 7 7 4 8 1 4v10l-4 10-7 8-8 4-4 1h-10l-9-3-9-8-4-8-1-3v-12l4-10 5-6 9-5z",
    fill: "#201E1F"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1013,508)",
    d: "m0 0h13l10 4 7 7 4 8 1 4v10l-4 10-7 8-8 4-4 1h-10l-9-3-9-8-4-8-1-3v-12l4-10 5-6z",
    fill: "#201E1F"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,1404)",
    d: "m0 0h39l1 1v54l-6 1-28 1-6 1z",
    fill: "#FEFEFE"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1405,1068)",
    d: "m0 0h11v56h-9l-11-4-8-8-4-10v-12l3-9 6-7z",
    fill: "#201E1F"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(617)",
    d: "m0 0h20l-1 3-4 1h-8l-7-2z",
    fill: "#201E1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRounded);
export default __webpack_public_path__ + "static/media/rounded.75bd9398455967bbfc9b90d9f89def8d.svg";
export { ForwardRef as ReactComponent };